// UTC offset by DXCC prefix
var TIMEZONE_MAP = {
  // South America
  "PY":-3,"LU":-3,"CE":-4,"CX":-3,"OA":-5,"HK":-5,"YV":-4,"HC":-5,"CP":-4,
  "ZP":-4,"9Y":-4,"8R":-4,"HP":-5,"HI":-4,"HH":-5,"CM":-5,"TI":-6,
  "YS":-6,"TG":-6,"HR":-6,"YN":-6,"V3":-6,
  // North America
  "K":-5,"VE":-5,"XE":-6,"KL":-9,"KH6":-10,"KP4":-4,
  // Europe
  "G":0,"F":1,"DL":1,"I":1,"EA":1,"CT":0,"PA":1,"ON":1,"LX":1,
  "HB":1,"OE":1,"OK":1,"SP":1,"HA":1,"YO":1,"YU":1,"LZ":2,
  "SV":2,"9A":1,"S5":1,"OM":1,"OZ":1,"SM":1,"LA":1,"OH":2,
  "ES":2,"YL":2,"LY":2,"EI":0,"UR":2,"UA":3,"EW":3,"ER":2,
  "4O":1,"Z3":1,"E7":1,"ZA":1,"9H":1,"3A":1,"T7":1,"HV":1,
  "1A":1,"TK":1,"IS":1,"TA":3,
  // Asia
  "JA":9,"HL":9,"BY":8,"BV":8,"VU":5.5,"HS":7,"9M2":8,"9M6":8,
  "9V":8,"DU":8,"YB":7,"VR":8,"4X":2,"HZ":3,"A4":4,"A6":4,
  "A7":3,"A9":3,"9K":3,"OD":2,"YK":3,"EP":3.5,"EK":4,
  "4J":4,"4L":4,"UK":5,"UN":6,"EX":6,"EY":5,"EZ":5,
  "AP":5,"S2":6,"4S":5.5,"9N":5.75,"XW":7,"XU":7,"XV":7,
  "3W":7,"XZ":6.5,"YI":3,
  // Oceania
  "VK":10,"ZL":12,"3D2":12,"5W":13,"FK":11,"FO":-10,
  "KH2":10,"T8":9,"V7":12,"T3":12,
  // Africa
  "SU":2,"5N":1,"5Z":3,"5H":3,"7X":1,"CN":1,"3V":1,
  "5A":2,"ST":2,"6W":0,"5T":0,"5X":3,"5R":3,"ZS":2,
  "7Q":2,"9J":2,"Z2":2,"A2":2,"7P":2,"3DA":2,"V5":2,
  "9G":0,"9L":0,"3C":1,"9Q":1,"5U":1,"5V":0,"TU":0,
  "EL":0,"TY":1,"TL":1,"TN":1,"TR":1,"TT":1,"TJ":1,
  // Caribbean
  "8P":-4,"J3":-4,"J6":-4,"J7":-4,"J8":-4,"V2":-4,"V4":-4,
  "6Y":-5,"ZF":-5,"C6":-5,"CO":-5,
  "FG":-4,"FM":-4,"FS":-4
};


// Get UTC offset from operator callsign
export function getTimezoneOffset(callsign) {
  if (!callsign) return 0;
  var call = callsign.toUpperCase().replace(/\/.*/, '');
  // Try longest prefix first (4,3,2,1 chars)
  for (var len = 4; len >= 1; len--) {
    var prefix = call.substring(0, len);
    if (TIMEZONE_MAP[prefix] !== undefined) return TIMEZONE_MAP[prefix];
  }
  // Common prefix patterns
  var p2 = call.substring(0, 2);
  var p1 = call.substring(0, 1);
  // Brazil
  if ('PP PQ PR PS PT PU PV PW ZV ZW ZX ZY ZZ'.indexOf(p2) >= 0) return -3;
  // USA
  if ('W N'.indexOf(p1) >= 0 && call.length > 3) return -5;
  if ('AA AB AC AD AE AF AG AI AJ AK'.indexOf(p2) >= 0) return -5;
  if ('KA KB KC KD KE KF KG KI KJ KK KM KN KO KQ KR KS KT KU KV KW KX KY KZ'.indexOf(p2) >= 0) return -5;
  if ('WA WB WC WD WE WF WG WI WJ WK WM WN WO WQ WR WS WT WU WV WW WX WY WZ'.indexOf(p2) >= 0) return -5;
  if ('NA NB NC ND NE NF NG NI NJ NK NM NN NO NQ NR NS NT NU NV NW NX NY NZ'.indexOf(p2) >= 0) return -5;
  // Germany
  if ('DA DB DC DD DE DF DG DH DI DJ DK DL DM DN DO DP DQ DR'.indexOf(p2) >= 0) return 1;
  // Japan
  if (p1 === 'J' && call.charAt(1) >= 'A' && call.charAt(1) <= 'S') return 9;
  // Russia
  if ('RA RV RW RX RZ'.indexOf(p2) >= 0) return 3;
  // Italy
  if ('IK IN IU IW IX IY IZ'.indexOf(p2) >= 0) return 1;
  // Spain
  if ('EB EC ED EE EF EG EH AM AN AO'.indexOf(p2) >= 0) return 1;
  // Argentina
  if ('LO LP LQ LR LS LT LV LW AY AZ'.indexOf(p2) >= 0) return -3;
  // UK
  if (p1 === 'M' || p1 === 'G' || p2 === '2E' || p2 === '2M') return 0;
  // Australia
  if (p2 === 'AX' || p2 === 'VK') return 10;
  // Ukraine
  if ('US UT UU UV UW UX UY UZ EM EN EO'.indexOf(p2) >= 0) return 2;
  // Poland
  if ('SN SO SQ SR HF'.indexOf(p2) >= 0) return 1;
  return 0;
}

// Format timezone label
export function tzLabel(offset) {
  if (offset === 0) return 'UTC';
  var sign = offset > 0 ? '+' : '';
  if (offset % 1 !== 0) {
    var h = Math.floor(Math.abs(offset));
    var m = Math.round((Math.abs(offset) % 1) * 60);
    return 'UTC' + (offset < 0 ? '-' : '+') + h + ':' + String(m).padStart(2, '0');
  }
  return 'UTC' + sign + offset;
}

// Adjust hour by offset (wraps 0-23)
export function adjustHour(utcHour, offset) {
  var h = Math.round((utcHour + offset) % 24);
  if (h < 0) h += 24;
  return h;
}
